import {
  EShortcutsDate,
  IDateRange,
  IShortcutHandler
} from "@/core/composables/F360DateShortcuts/types";
import { IMapNamesShortcut } from "@/core/composables/types";
import type { IF360DateUtils } from "@/core/plugins/date/F360DateUtils";
import { F360UnitDate, type IF360Date } from "@/core/plugins/date/F360Date";
import { inject, injectable } from "inversify";
import { DITypes } from "@/core/@types/types";
import "reflect-metadata";
@injectable()
export default class ShortcutObrigacoesHandler
  implements IShortcutHandler<string>
{
  shortcuts: Map<EShortcutsDate<string>, IDateRange>;
  shortcutNames: IMapNamesShortcut<string>;

  private date!: IF360Date;

  private dateUtils!: IF360DateUtils;

  constructor(
    @inject(DITypes.DATE) date: IF360Date,
    @inject(DITypes.DATE_UTILS) dateUtils: IF360DateUtils
  ) {
    this.date = date;
    this.dateUtils = dateUtils;

    const shortcuts = [...Array.from({ length: 5 }).keys()].map((index) =>
      this.date.subtract(this.date.now(), index, F360UnitDate.Year)
    );

    const shortcutsKeys = shortcuts.map((shortcut) => shortcut.getFullYear());

    this.shortcuts = new Map<EShortcutsDate<string>, IDateRange>(
      shortcutsKeys.map((year) => [
        year,
        this.dateUtils.formatToDateRange(
          this.date.subtract(this.date.now(), year, F360UnitDate.Year)
        )
      ])
    );

    this.shortcutNames = shortcutsKeys.map((year) => [year, year.toString()]);
  }

  handle(payload: EShortcutsDate<string>): IDateRange | undefined {
    const rangeDate = this.shortcuts.get(payload) || undefined;

    return rangeDate;
  }
}
